<script>
  import {push} from "../EndpointsAndTransforms";
  import {createEventDispatcher} from "svelte";

  const dispatch = createEventDispatcher()
  function loadRant(name) {
    dispatch('load', {'rant': name} )
  }
</script>

<main>
  <item on:click="{() => {
    push('rants/fullStack')
    loadRant('fullStack')
  }}">
    <h1>The Server-Side-Swift & AWS stack Federighi doesn't want you to know about!</h1>
    <p><img src="/images/StackDiagram.png"/>I don't actually know Craig, and he probably would be happy if you read about my
    stack!</p>
    <p>Honestly I just put the words 'Swift' 'AWS' and 'Federighi' in there to punch up the
      headline a bit and make this one more clickable.</p>
    <p>Don't worry though, I've got plenty of
      server-side-swift and AWS content for you here! You should definitely click this one.</p>
    <p>We'll look at the tooling/infrastructure/languages that make up my stack, and we'll look
      closer at the modeling supporting my Swift Lambda functions. I'll also share a bit about
      the journey from 10+ years in iOS to full-stack development with serverless infrastructure.
    </p>
  </item>

  <dividerLine/>

  <item on:click="{() => {
    push('rants/jwtLambda')
    loadRant('jwtLambda')
  }}">
    <h1>JWT validation and parsing with swift executables. But can we make Lambda do it?</h1>
    <p><img src="/images/geordiJWT.jpg"/> </p>
    <p>So there you are again; it's Saturday night in 2021 and all your cool engineer friends
      are tokenizing everything in sight and writing their tokens into a blockchain.</p>
    <p>But you're not interested in turning your cat into a token, just so a warehouse full of
      gaming GPU's can burn 1MWh of electricity to write Mr. Mittens' name down next to yours on
      a distributed ledger.</p>
    <p>No, you promised yourself you'd keep a level head and stay grounded in your roots. So
      what can you do to keep up with your friends, and still stay true to yourself?</p>
    <p>What about taking an 11 year old idea to use JSON for cryptography, and see if you can't
      deploy it as an AWS Lambda function by writing some Swift??!?</p>
    <h3>Let's do this!!</h3>
  </item>

  <dividerLine/>

</main>

<style>
  main {
    text-align: left;
    display: flex;
    flex-direction: column;
    width: 97%;
    max-width: 800px;
    margin-right: auto;
    margin-left: auto;
    padding-left: 1rem; padding-right: 1rem; padding-top: 2rem;
    overflow-x: hidden;
    overflow-y: scroll;
    scrollbar-width:none;
  }
  main::-webkit-scrollbar {
    display: none;
  }
  item {
    padding-left: 2rem; padding-right: 2rem; padding-bottom: 2rem;
  }
  item:hover {
    box-shadow: -2px 9px 10px -4px #272d35, 0px -9px 10px -4px #272d35;
    border-radius: 8px;
    background-color: rgb(248,248,248);
  }
  img {
    max-width: 45%;
    height: auto;
    margin: 8px;
    float: right;
    -webkit-filter: drop-shadow(5px 7px 5px #272d35);
    filter: drop-shadow(5px 7px 5px #272d35);
  }
  dividerLine {
    background-color: rgba(107,118,141,0.3);
    width: 100%;
    height: 1px;
    margin-top: 6rem;
    margin-bottom:2rem;
  }
  h2 {
    font-size: 2.1rem;
  }
  h2:hover {
    color: blue;
    text-decoration: underline;
    cursor: pointer;
  }
  p {
    font-size: 1.2rem;
  }

  @media screen and (max-width: 1000px){
    h1 { font-size: 2.0rem; }
    h2 { font-size: 1.8rem; }
  }
  @media screen and (max-width: 600px){
    h1 { font-size: 1.7rem; }
    h2 { font-size: 1.4rem; }

    main {
      max-width: 97%;
      overflow-x: hidden;
    }
  }
</style>
